/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import {
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'carbon-components-react';
import React from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage, useIntl } from 'react-intl';

import { Noop } from '../../../../ts';
import { messages } from './messages';

import './CancelConfirmationModal.scss';

export interface CancelConfirmationModalProps {
  modalBodyText: string;
  isOpen: boolean;
  primaryButtonDisabled: boolean;
  onCancel: Noop;
  onClose: Noop;
  onSubmit: Noop;
}
export const CancelConfirmationModal: React.FC<
  CancelConfirmationModalProps
> = ({
  modalBodyText,
  onCancel,
  onClose,
  onSubmit,
  isOpen,
  primaryButtonDisabled
}) => {
  const intl = useIntl();

  return ReactDOM.createPortal(
    <ComposedModal
      data-testid="cancel-confirmation-modal"
      className="CancelConfirmationModal"
      open={isOpen}
      onClose={onCancel}>
      <ModalHeader>
        <div className="CancelConfirmationModal__title">
          <FormattedMessage {...messages.unsavedEdits} />
        </div>
      </ModalHeader>
      <ModalBody>
        {modalBodyText || <FormattedMessage {...messages.saveEditsBody} />}
      </ModalBody>
      <ModalFooter
        primaryButtonText={intl.formatMessage(messages.save)}
        secondaryButtonText={intl.formatMessage(messages.discardEdits)}
        primaryButtonDisabled={primaryButtonDisabled}
        onRequestSubmit={onSubmit}
        onRequestClose={onClose}
      />
    </ComposedModal>,
    document.body
  );
};
